import axios from 'axios'
import store from '@/store'
import {errorNotify} from "./alertutil";
import {getToken} from '@/utils/auth'
import alertify from 'alertifyjs'

import {v4 as uuidv4} from 'uuid'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 10 * 60 * 1000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers = {
      'Content-Type': 'application/json', //
      'channel': 'pc-web'
    };
    // config.data.dataSourceFaly='03';
    config.data.txnReqSsn = uuidv4()
      .split("-")
      .join("");
    let date = new Date();
    let timer1, timer2;
    timer1 =
      String(date.getFullYear()) +
      (date.getMonth() + 1 < 10
        ? 0 + String(date.getMonth() + 1)
        : String(date.getMonth() + 1)) +
      (date.getDate() < 10 ? 0 + String(date.getDate()) : String(date.getDate()));
    timer2 =
      (date.getHours() < 10
        ? 0 + String(date.getHours())
        : String(date.getHours())) +
      (date.getMinutes() < 10
        ? 0 + String(date.getMinutes())
        : String(date.getMinutes())) +
      (date.getSeconds() < 10
        ? 0 + String(date.getSeconds())
        : String(date.getSeconds()));
    config.data.txnReqTm = timer1 + timer2;
    config.data.lang = 'en';
    config.data.version='1.0.0';

    // Do something before request is sent
    // const tk = getToken()
    // console.log("interceptors token", tk)
    // if (tk) {
    //   // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    //   config.headers['tk'] = tk
    // }
    // 特殊接口超时时间特殊处理
    // if (config.url.search('kunya-service-report-export') != -1) {
    //   config.timeout = 20000;
    // } else {
    //   config.timeout = 5000;
    // }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    var res=response.data;
    if (res.respCode !== '0000') {
      errorNotify(res.respMsg);
      return Promise.reject(res.respMsg);
    } else {
      console.log('response suceess', res);
      return res
    }
  },
  error => {
    if (error.response && error.response.status == 504) {

      errorNotify('Unable to connect to the server, please refresh or try again later')


    } else if (error.response && error.response.status == 403) {

      errorNotify('The resource you accessed does not exist, please refresh the page and cache or contact the administrator')

    } else {
      errorNotify(error.message)
    }

    return Promise.reject(error)
  }
)

export default service
